export default __webpack_public_path__ + "static/martha-geilman-3-be6046ce3b3f2bca4e1ae31046df0b60.png";